export const borderLeftSubTitle = [
    {
        text: 'Use the class of',
        code: '.b-l-* '
    },
    {
        text: 'for left border.'
    }
];

export const borderRightSubTitle = [
    {
        text: 'Use the class of',
        code: '.b-r-* '
    },
    {
        text: 'for right border.'
    }
];

export const borderTopSubTitle = [
    {
        text: 'Use the class of',
        code: '.b-t-* '
    },
    {
        text: 'for top border.'
    }
];

export const borderBottomSubTitle = [
    {
        text: 'Use the class of',
        code: '.b-b-* '
    },
    {
        text: 'for bottom border.'
    }
];

export const borderPrimarySubTitle = [
    {
        text: 'Use the class of',
        code: '.b-l-* '
    },
    {
        text: 'for left border and ',
        code: '.border-3 '
    },
    {
        text: 'is used to increase the width of the border.'
    }
];

export const borderPrimaryData = [
    {
        id: 1,
        image: '1.jpg',
        name: 'Teresa J. Mosteller'
    },
    {
        id: 2,
        image: '3.png',
        name: 'Gloria D. Acheson'
    },
    {
        id: 3,
        image: '5.jpg',
        name: 'Bryan A. Owens'
    },
];

export const borderWarningData = [
    {
        id: 1,
        color: 'primary',
        text: 'known for delivery of useful and usable solutions'
    },
    {
        id: 2,
        color: 'danger',
        text: 'Solve your problem with us'
    },
    {
        id: 3,
        color: 'success',
        text: 'Certified Professionals'
    },
    {
        id: 4,
        color: 'warning',
        text: 'Growth-Driven'
    },
]

export const borderSecondaryData = [
    {
        text: 'Stella Nowland',
        class: 'warning',
        text2: 'Freelance'
    },
    {
        text: 'Lola Stanford',
        class: 'danger',
        text2: 'Issue'
    },
    {
        text: 'Caitlin Coungeau',
        class: 'primary',
        text2: 'Social'
    },
    {
        text: 'Graciela McClaran',
        class: 'danger',
        text2: 'Issue'
    }
]